module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/point02-0491927caa7f6bc623a4265df0592763.png";